import React, { useEffect, useState } from "react";
import { Box, Typography, TableCell, Fab } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import {
  StyledTableCell,
  StyledTableRow,
  TableWrapper,
} from "../../../../component";
import ApiManager from "../../../../services/api-manager";
import usePageTitle from "../../../../hooks/use-page-title";
import Utils from "../../../../utils/utils";

// TODO: refund work remains
// TODO: Final Quantity and Final Amount work remains

const OrdersDetails = () => {
  usePageTitle("Order Details");
  const [isLoading, setIsLoading] = useState(false);
  const [records, setRecords] = useState(null);
  const { id, orderId } = useParams();
  const navigate = useNavigate();
  const { user, loggedEvent } = useSelector((state) => state.storeReducer);
  const _role = user?.role === "super_admin" ? "superAdmin" : "organizer";
  const _symbol = loggedEvent.currencySymbol;

  useEffect(() => {
    getData();
  }, [id]);

  const getData = async (_search = "") => {
    try {
      setIsLoading(true);
      let { data } = await ApiManager(
        "get",
        `${_role}/order-details/${orderId}`,
      );
      console.log("showing data: ", data?.items);
      setRecords(data);
    } catch (error) {
      console.log("🚀 ~ file: events.js:47 ~ getData ~ error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Box>
        <Fab
          size="small"
          onClick={() =>
            // navigate(`/event/${id}/management/lead-capture/revenue-report`)
            navigate(-1)
          }
        >
          <ArrowBackIcon />
        </Fab>
        <Typography variant="h4" color="initial" fontWeight="bold" m={2}>
          Order Details -{" "}
          {records?.device?.vendor_devices?.vendor?.name || "...Loading"}
        </Typography>

        <TableWrapper
          spanTd={thLabels.length}
          isLoading={isLoading}
          isContent={records?.items?.length || false}
          thContent={
            <>
              {thLabels.map((v) => (
                <TableCell key={v}>{v}</TableCell>
              ))}
            </>
          }
        >
          {records?.items?.map((item, i) => (
            <StyledTableRow key={i}>
              <StyledTableCell>{item?.product?.name}</StyledTableCell>
              <StyledTableCell>
                {_symbol}
                {item?.price}
              </StyledTableCell>
              <StyledTableCell>{item?.quantity}</StyledTableCell>
              <StyledTableCell>
                {_symbol}
                {item?.sub_total}
              </StyledTableCell>
              <StyledTableCell>{item?.refund_quantity}</StyledTableCell>
              <StyledTableCell>
                {_symbol}
                {item?.refund_amount}
              </StyledTableCell>
              <StyledTableCell>
                {Utils.capitalize(item?.happy_hour)}
              </StyledTableCell>
              <StyledTableCell>{item?.discounted_percentage}%</StyledTableCell>
              <StyledTableCell>{item?.final_quantity}</StyledTableCell>
              <StyledTableCell>
                {_symbol}
                {item?.final_amount}
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableWrapper>
      </Box>
    </div>
  );
};

const thLabels = [
  "Product Name",
  "Price",
  "Quantity",
  "Amount",
  "Refunded Quantity",
  "Refunded Amount",
  "Happy Hour",
  "Discount",
  "Final Quantity",
  "Final Amount",
];

export default OrdersDetails;
